import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { GlobalAppService } from '@app/Modules/Shared/Services/global-app.service';
import { HttpService } from '@app/Modules/Shared/Services/http.service';

@Component({
  selector: 'app-promotions',
  templateUrl: './promotions.component.html',
  styleUrls: ['./promotions.component.scss']
})
export class PromotionsComponent implements OnInit {
  usaPDF: Array<any>;
  usaExcel: Array<any>;
  canadaPDF: Array<any>;
  canadaExcel: Array<any>;
  containerName : string;

  accordionMenus: Array<any> = [
    {"name": "USA", "expanded": false, "submenus": [
      {"name": "PDF", "expanded": false, "promotions": [
        {"name": "test"}
      ]},
      {"name": "Excel", "expanded": false, "promotions": [
        {"name": "test"}
      ]}
    ]}, 
    {"name": "Canada", "expanded": false, "submenus": [
      {"name": "PDF", "expanded": false, "promotions": [
        {"name": "test"}
      ]},
      {"name": "Excel", "expanded": false, "promotions": [
        {"name": "test"}
      ]}
    ]}
  ]

  constructor(
    private _appService: AppService,
    private httpService: HttpService,
    private activatedRoute: ActivatedRoute,
    private _globalAppService: GlobalAppService,
     ) 
  {   
  }

  ngOnInit() {
    this.GetPromotionFiles();
  }

  toggleCollapse(event, group) {
    var id;
    var content;
    var element;
    
    if(event.target.tagName === "I")
    {
      id = event.target.parentElement.id;
      content = event.target.parentElement.nextElementSibling;
    }
    else{
       id = event.target.id;
       element = event.target;
       content = element.nextElementSibling;
    }

    if (content.style.display === "block") {
      content.style.display = "none";
      group.expanded = false;
    } else {
      content.style.display = "block";
      group.expanded = true;
    }
  };

  GetPromotionFiles()
  {
    this.accordionMenus = [];
    this.usaPDF =[];
    this.usaExcel =[];
    this.canadaPDF = [];
    this.canadaExcel =[];
    this.containerName = "promotions";
    this.httpService.GetPromotionFilesFromBlobStorage(this.containerName).subscribe(item => {
      for (let i = 0; i < item.length; i++) {
        if (item[i].name.includes('US/PDF/') && !item[i].name.includes('archive/')) {
          let usaPDF = {
            "name": item[i].fileDisplayName,
            "url": item[i].uri
          };
          this.usaPDF.push(usaPDF);
        }  else if (item[i].name.includes('US/XSLX/') && !item[i].name.includes('archive/')) {
          let usaExcel = {
            "name": item[i].fileDisplayName,
            "url": item[i].uri
          }
          this.usaExcel.push(usaExcel);
        }
          else if (item[i].name.includes('CAN/PDF/') && !item[i].name.includes('archive/')) {
          let canadaPDF = {
            "name": item[i].fileDisplayName,
            "url": item[i].uri
          };
          this.canadaPDF.push(canadaPDF);
        } else if (item[i].name.includes('CAN/XSLX/') && !item[i].name.includes('archive/')) {
          let canadaExcel = {
            "name": item[i].fileDisplayName,
            "url": item[i].uri
          };
          this.canadaExcel.push(canadaExcel);
        }
       }
        this.buildAccordionMenus()

    })
  }
  
  buildAccordionMenus(){
    //Build USA portion of accordion object
    let usa = {"name": "USA", "expanded": false, "submenus": []}
    //USA PDF
    let uPDF = {"name": "PDF", "expanded": false, "promotions": []}
    this.usaPDF.forEach(element => {
      uPDF.promotions.push(element);
    });
    usa.submenus.push(uPDF);
    //USA Excel
    let uXL = {"name": "Excel", "expanded": false, "promotions": []}
    this.usaExcel.forEach(element => {
      uXL.promotions.push(element);
    });
    usa.submenus.push(uXL);
    this.accordionMenus.push(usa);

    //Build Canada portion of accordion object
    let can = {"name": "Canada", "expanded": false, "submenus": []}
    //Canada PDF
    let cPDF = {"name": "PDF", "expanded": false, "promotions": []}
    this.canadaPDF.forEach(element => {
      cPDF.promotions.push(element);
    });
    can.submenus.push(cPDF);
    //Canada Excel
    let cXL = {"name": "Excel", "expanded": false, "promotions": []}
    this.canadaExcel.forEach(element => {
      cXL.promotions.push(element);
    });
    can.submenus.push(cXL);
    this.accordionMenus.push(can);
  }

}
